import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Stack, Typography, Alert, Chip, Divider, Link, Button } from '@mui/material';
import { Language } from '@mui/icons-material';

const previousReadStateKey = 'read_state_roach';
const readStateKey = 'read_state_eggy_sal';

const WelcomeDialog = ({ onOpenLangDialog }) => {
  const [hasReadIntro, setHasReadIntro] = useState(true);

  useEffect(() => {
    localStorage.removeItem(previousReadStateKey);
    const readState = JSON.parse(localStorage.getItem(readStateKey) || 'false');
    setHasReadIntro(readState);
  }, []);

  const handleAcknowledgeIntro = () => {
    localStorage.setItem(readStateKey, JSON.stringify(true));
    setHasReadIntro(true);
  };

  return (
    <Dialog
      open={!hasReadIntro}
      onClose={handleAcknowledgeIntro}
      maxWidth="sm"
      fullWidth
      hideBackdrop={hasReadIntro}
      disableScrollLock={!hasReadIntro}
      sx={{
        pointerEvents: 'none',
        '& .MuiDialog-container': {
          pointerEvents: 'none',
        },
        '& .MuiPaper-root': {
          pointerEvents: 'auto',
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="h6" component="div">Welcome to Party Animals Helper 🎉</Typography>
        </Stack>
      </DialogTitle>

      <DialogContent sx={{ pt: 1 }}>
        <Alert
          severity="info"
          variant="outlined"
          sx={{ mb: 2, alignItems: 'center' }}
        >
          <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap">
            <Chip size="small" color="secondary" label="New" />
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Goodbye 67! We now have 69 friends. Say hello to Eggy and Sal 👋
            </Typography>
          </Stack>
        </Alert>
        <Divider sx={{ my: 2 }} />

        <Typography variant="caption" sx={{ display: 'block', opacity: 0.8 }}>
          Want your language added? Contribute translations &rarr; <Link href="https://crowdin.com/project/party-animals-helper" target="_blank" variant="caption">Here</Link>
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          variant="outlined"
          onClick={onOpenLangDialog}
          startIcon={<Language />}
        >
          Change language
        </Button>
        <Button onClick={handleAcknowledgeIntro} variant="contained" color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WelcomeDialog;
